import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { ActivityBlock } from '../../abstract/ActivityBlock.js';
export class StartFrom extends ActivityBlock {
  constructor() {
    super(...arguments);
    _defineProperty(this, "historyTracked", true);
    /** @type {import('../../abstract/ActivityBlock.js').ActivityType} */
    _defineProperty(this, "activityType", 'start-from');
  }
  initCallback() {
    super.initCallback();
    this.registerActivity(this.activityType);
  }
}
StartFrom.template = /* HTML */" <div class=\"content\"><slot></slot></div> ";